import React from 'react';
import PropTypes from 'prop-types';
import './BodyStyle.css'; // Import the CSS file

const BodyMediumMedium = ({ text, color }) => {
  return (
    <p className="body-medium-medium" style={{ color: color }}>
      {text}
    </p>
  );
};

BodyMediumMedium.propTypes = {
  text: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
};

export default BodyMediumMedium;